import { useUnit } from 'effector-react'
import {
  $exDifferenceList,
  $walletOptions,
  $currencyOptions,
  getExDifferenceListFx,
} from 'src/pages/finSystem/balanceSummary/reports/reportExDifference/model'

export const useExDifferenceList = () => {
  const exDifferenceList = useUnit($exDifferenceList)
  const loading = useUnit(getExDifferenceListFx.pending)

  return { exDifferenceList, loading }
}

export const useWalletOptions = () => {
  const walletOptions = useUnit($walletOptions)
  const currencyOptions = useUnit($currencyOptions)

  return { walletOptions, currencyOptions }
}
